export function populateTwoHeader(jsonData){

    headingText = jsonData.header.data.content.text.heading.value;
    subText = jsonData.header.data.content.text.subText.value;
    bannerImage = jsonData.header.data.images[0].path;
    logoImage = jsonData.header.data.content.text.logoImage.path;

    $("link[rel='shortcut icon']").attr('href', jsonData.favicon);

    if(!$(document).find(".preview").hasClass("hidden")){
        $("p#headerHeading").html(headingText);
        $("p#headerSubText").html(subText);

        if(jsonData.header.data.images.length > 1){
            $(".bannerTwo__viewPhotos").removeClass("hidden");  
        }
    }
    else{                            
        $("input#headerHeading").val(headingText);
        $("textarea#headerSubText").val(subText);

        $(".bannerTwo__viewPhotos").removeClass("hidden");        
    }

    if(bannerImage){
        // $(".bannerTwo__banner-image").attr("src", bannerImage);
        $(".bannerTwo__banner-image").attr("data-src", bannerImage);

        if(bannerImage.indexOf('_cropped')>-1){
            $(".bannerTwo__banner-image").attr("data-original-src", bannerImage.split('_cropped')[0] + '.jpg');

            if($(window).width() < 768){
                $(".bannerTwo__banner-image").attr('src', bannerImage.split('_cropped')[0] + '_cropped2.jpg');    
            }
            else{
                $(".bannerTwo__banner-image").attr('src', bannerImage);   
            }
        }
        else{
            $(".bannerTwo__banner-image").attr("data-original-src", bannerImage);
            $(".bannerTwo__banner-image").attr('src', bannerImage);
        }

    }
    
    if(logoImage){
        $(".bannerTwo__company-logo").attr("src", logoImage);
        $(".bannerTwo__company-logo").attr("data-src", logoImage);

        if(logoImage.indexOf('_cropped')>-1){
            $(".bannerTwo__company-logo").attr("data-original-src", logoImage.split('_cropped')[0] + '.jpg');
        }
        else{
            $(".bannerTwo__company-logo").attr("data-original-src", logoImage);
        }
    }
}